/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../utils/apiClient';
import {
  restructureUserReferralModel,
  restructureUserReferralTotalModel
} from './restructuring';
import { restructurePaginationModel } from '../../../common/restructuring';

class UserReferralService {
  async getUserReferralsAuthUser(state, queryParams) {
    const response = await api.get('/user-referral/me-v2', {
      expand: 'referral.profile',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data.list.items, item =>
            restructureUserReferralModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data.list.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data.list._meta')
        ),
        total: restructureUserReferralTotalModel(
          state,
          _.get(responseJson, 'data.total')
        )
      }
    };
  }
}

export default new UserReferralService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userReferral/services/UserReferralService.js